import { Component, Input, OnInit } from '@angular/core';
import * as _ from 'lodash';

@Component({
  selector: 'app-external-notes-viewer',
  templateUrl: './external-notes-viewer.component.html',
  styleUrls: ['./external-notes-viewer.component.less']
})
export class ExternalNotesViewerComponent implements OnInit {

  @Input() value: any;
  public showList=true;
  constructor() { }

  ngOnInit(): void {
    
    if(_.isEmpty(this.value)){
      this.showList=false;
    }
  }

}
